export interface IOfflineStorage {
  get(key: string): Promise<string | null>;
  set(key: string, value: string | null): Promise<void>;
}

export class OfflineStorage implements IOfflineStorage {
  constructor(private driver: Storage) {

  }

  public async get(key: string): Promise<string | null> {
    return this.driver.getItem(key);
  }

  public async set(key: string, value: string | null): Promise<void> {
    if (value === null) {
      return this.driver.removeItem(key);
    }
    return this.driver.setItem(key, value);
  }
}

export function createOfflineStorage(driver = localStorage): IOfflineStorage {
  return new OfflineStorage(driver);
}
